import { useEffect, useState } from "react";
import ForgetPasswordForm from "./ForgetPasswordForm";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // دعم الترجمة

export default function ForgetPassword() {
  const { t } = useTranslation(); // استخدام الترجمة
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token_Front_Mied");

    if (token) {
      navigate("/");
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [navigate]);

  if (loading) {
    return <div>{t("Loading...")}</div>; // عرض رسالة أثناء التحميل
  }

  return (
    <div className={`auth right-panel-active`} id="container">
      <ForgetPasswordForm />
      <div className="overlay-container">
        <div className="overlay-auth">
          <div className="overlay-panel overlay-left">
            <h1>{t("Welcome Back!")}</h1>
            <p>
              {t("If you forgot your password, you can regain access by resetting it here.")}
            </p>
          </div>
          <div className="overlay-panel overlay-right">
            <h1>{t("Hello, Friend!")}</h1>
            <p>{t("Enter your personal details and start journey with us")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
